"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * German localization
 */
exports.default = {
    didNotBackUpWallet: 'Wenn Sie Ihr Zertifikat nicht gesichert haben oder Ihr Telefon verloren haben, kontaktieren Sie den Support unter @TicketheadSupport.',
    nft: 'Head',
};
//# sourceMappingURL=de.js.map